import { BaseViewStore, BaasicDropdownStore, BasicQueryCheckboxStore } from 'core/stores';
import { observable, action } from 'mobx';
import { NikoPatientService, NikoPatientDetailService } from "application/niko-patient/services";
import { FacilityService } from 'application/facility/services';
import applicationContext from 'core/utils/applicationContext';
import { QueryUtility } from 'core/utils';
import { CorporateService } from 'application/corporate/services';

@applicationContext
class TemplateReportViewStore extends BaseViewStore {
    @observable accessor disabled = false;
    @observable accessor previousIncludeHospitalValue;
    constructor(rootStore) {
        super(rootStore);

        this.nikoPatientDetailService = new NikoPatientDetailService(rootStore.application.baasic.apiClient);
        this.nikoPatientService = new NikoPatientService(rootStore.application.baasic.apiClient);
        this.facilityService = new FacilityService(rootStore.application.baasic.apiClient);
        this.corporateService = new CorporateService(rootStore.application.baasic.apiClient);
        this.createFacilityStore();
        this.createPatientStore();
        this.createCorporateStore();
        this.queryUtility = new QueryUtility(rootStore, () => { }, {});
        this.includeAllCheckboxStore = new BasicQueryCheckboxStore();
        this.includeHospitalCheckboxStore = new BasicQueryCheckboxStore();
    }

    createFacilityStore() {
        this.facilityStore = new BaasicDropdownStore(
            {
                filterable: true
            },
            {
                fetchFunc: async (term) => {
                    const response = await this.facilityService.find({ searchQuery: term, rpp: 10, isNiko: true });
                    return response.data.item;
                }
            }
        );
    }

    createPatientStore() {
        this.patientStore = new BaasicDropdownStore(
            {
                filterable: true
            },
            {
                fetchFunc: async (term) => {
                    const response = await this.nikoPatientService.find({ searchQuery: term, rpp: 10, excludeMasterPatients: true });
                    return response.data.item.map(person => ({ id: person.id, name: `${person.lastName}, ${person.firstName} (${person.displayId})` }));
                }
            }
        );
    }

    createCorporateStore(){
        this.corporateStore = new BaasicDropdownStore({ filterable: true }, 
        {
            fetchFunc: async(term) => {
                const response = await this.corporateService.find({ isNiko: true, searchQuery: term, rpp: 100 });
                return response.data.item;          
            }
        });
    }

    @action.bound
    onIncludeAllChange(event) {
        const value = event.target.checked;
        this.queryUtility.filter.toggle('includeAll');
        this.includeAllCheckboxStore.setValue(value);
        this.disabled = value;

        if (value) {
            this.previousIncludeHospitalValue = this.includeHospitalCheckboxStore.value;

            if (!this.includeHospitalCheckboxStore.value) {
                this.includeHospitalCheckboxStore.setValue(true);
                this.queryUtility.filter.toggle('includeHospital');
            }
        } else {
            const restoreValue = this.previousIncludeHospitalValue != null ? this.previousIncludeHospitalValue : false;

            if (this.includeHospitalCheckboxStore.value !== restoreValue) {
                this.includeHospitalCheckboxStore.setValue(restoreValue);
                this.queryUtility.filter.toggle('includeHospital');
            }

            this.previousIncludeHospitalValue = null;
        }
    }

    @action.bound
    onIncludeHospitalChange(event) {
        const value = event.target.checked;
        this.queryUtility.filter.toggle('includeHospital');
        this.includeHospitalCheckboxStore.setValue(value);
    }

    @action.bound
    async downloadReport() {
        const response = await this.nikoPatientDetailService.downloadReport(this.queryUtility.filter);
        this.downloadUrl = `${response}${response.endsWith('template-report/') ? '?' : '&'}contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl
            }&ttype=${this.rootStore.authStore.token.type}`;
        window.open(this.downloadUrl, "_blank");
    }
}

export default TemplateReportViewStore;